export var dataHooks = {
  removeButton: 'tag-remove-button',
  text: 'tag-text'
};